export enum Roles {
	SystemAdmin = 1,
	ProgramAdmin = 2,
	ProgramManager = 3,
	Instructor = 4,
}
